import { render, staticRenderFns } from "./home.pug?vue&type=template&id=09f2b217&lang=pug&external"
import script from "./home.js?vue&type=script&lang=js&external"
export * from "./home.js?vue&type=script&lang=js&external"
import style0 from "./home.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09f2b217')) {
      api.createRecord('09f2b217', component.options)
    } else {
      api.reload('09f2b217', component.options)
    }
    module.hot.accept("./home.pug?vue&type=template&id=09f2b217&lang=pug&external", function () {
      api.rerender('09f2b217', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Claim/views/home/index.vue"
export default component.exports